import { CalendarPlus, Download } from "lucide-react";
import { API } from "@/lib/api";

export const CalendarButtons = ({ electorate }) => {
  const ics = `${API}/calendar/${encodeURIComponent(electorate)}.ics`;
  const webcal = ics.replace(/^https?:\/\//, "webcal://");
  const google = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcal)}`;
  const cls = "inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-[#D8D2C4] bg-white text-xs font-semibold text-[#1B2A41] hover:border-[#E2705A] hover:text-[#E2705A] transition-colors";
  return (
    <div data-testid="calendar-buttons" className="flex flex-wrap gap-2">
      <a href={google} target="_blank" rel="noopener noreferrer" data-testid="calendar-google-button" className={cls}><CalendarPlus className="w-3.5 h-3.5" /> Google Calendar</a>
      <a href={webcal} data-testid="calendar-apple-button" className={cls}><CalendarPlus className="w-3.5 h-3.5" /> Apple / Outlook</a>
      <a href={ics} download={`roan-${electorate}.ics`} data-testid="calendar-ics-button" className={cls}><Download className="w-3.5 h-3.5" /> .ics</a>
    </div>
  );
};
